import MethodsProvider from "../providers/MethodsProvider";

export default {
    state: {
        paymentMethods: null,
    },
    getters: {
        getPaymentMethods: (state) => {
            return state.paymentMethods
        },

    },
    actions: {
        findPaymentMethods({commit}) {
            return new Promise((resolve, reject) => {
                MethodsProvider.findPaymentMethods()
                    .then(res => {
                        commit('setPaymentMethods', res.data.paymentMethodsFind)
                        resolve(res.data.paymentMethodsFind)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updatePaymentMethods({state, commit}) {
            return new Promise((resolve, reject) => {
                if (!state.paymentMethods) {
                    return reject('payment methods was no set')
                }
                MethodsProvider.updatePaymentMethods(
                    {
                        title: state.paymentMethods.title,
                        cash: {
                            enable: state.paymentMethods.cash.enable,
                            modes: state.paymentMethods.cash.modes,
                            info: state.paymentMethods.cash.info,
                            discount: state.paymentMethods.cash.discount,
                        },
                        debit: {
                            enable: state.paymentMethods.debit.enable,
                            modes: state.paymentMethods.debit.modes,
                            info: state.paymentMethods.debit.info,
                            discount: state.paymentMethods.debit.discount,
                        },
                        bankTransfer: {
                            enable: state.paymentMethods.bankTransfer.enable,
                            modes: state.paymentMethods.bankTransfer.modes,
                            info: state.paymentMethods.bankTransfer.info,
                            cbu: state.paymentMethods.bankTransfer.cbu,
                            alias: state.paymentMethods.bankTransfer.alias,
                            titular: state.paymentMethods.bankTransfer.titular,
                            discount: state.paymentMethods.bankTransfer.discount,
                        },
                        mercadoPagoTransfer: {
                            enable: state.paymentMethods.mercadoPagoTransfer.enable,
                            modes: state.paymentMethods.mercadoPagoTransfer.modes,
                            info: state.paymentMethods.mercadoPagoTransfer.info,
                            cvu: state.paymentMethods.mercadoPagoTransfer.cvu,
                            alias: state.paymentMethods.mercadoPagoTransfer.alias,
                            titular: state.paymentMethods.mercadoPagoTransfer.titular,
                            discount: state.paymentMethods.mercadoPagoTransfer.discount,
                        }
                    }


                )
                    .then(r => {
                        commit('setPaymentMethods', r.data.paymentMethodsUpdate)
                        resolve(r.data.paymentMethodsUpdate)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })

        }
    },
    mutations: {
        setPaymentMethods(state, val) {
            state.paymentMethods = val
        },

    }
}
